<script>
import QuestionTooltip from "@/components/app/policyCancel/components/QuestionTooltip.vue";
import FileInput from "@/components/app/policyCancel/components/FileInput.vue";

export default {
    name: "TasPolicyCancel",
    components: {FileInput, QuestionTooltip},
    model: {
        prop: 'dataForm',
        event: 'input',
    },
    props: {
        dataForm: {
            type: Object,
            default: function () {
                return {
                  reason: null,
                }
            }
        },
        moduleId: {
            // type: Integer,
            default: function () {
                return '';
            }
        },
        companyName: {
            type: String,
            default: function () {
                return '';
            },
        },
    },
    data() {
        return {
            checked: false,
        }
    },
    watch: {
        dataForm: {
            handler: function (val) {
                this.$emit('is-fill-form', val.reason);
            },
            deep: true
        }
    },
    mounted() {
      this.$emit('is-fill-form', false);
    }
}
</script>

<template>
    <div class="policy-cancel-custom">
<!--        <question-tooltip>-->
<!--            УВАГА! Заява має бути від імені клієнта,  з вірними датами та повністю заповнена, інакше страхові компанії можуть відмовити в ануляції договору.-->
<!--        </question-tooltip>-->
        <el-row>
            <el-col class="title mb-4">
                <label><b>Причина ануляції</b></label>
                <el-input placeholder="Причина ануляції"
                          v-model="dataForm.reason"></el-input>
            </el-col>
        </el-row>
    </div>
</template>

<style scoped>
* >>> .el-checkbox__input {
    vertical-align: super;
}
</style>
